import { PlatformLinkingProviderEntity } from '@okletsplay/core';
import { createEntityAdapter } from '@reduxjs/toolkit';
import { PlatformLinkingState } from 'modules/platform-linking/store/interfaces';
import { PlatformLinkingStoreStatus } from 'modules/platform-linking/store/enums';

export const entityAdapter = createEntityAdapter<PlatformLinkingProviderEntity>({
  selectId: (data) => data.platformId,
});

export const initialState: PlatformLinkingState = entityAdapter.getInitialState({
  status: {
    [PlatformLinkingStoreStatus.Loading]: [],
    [PlatformLinkingStoreStatus.Unlinking]: [],
    [PlatformLinkingStoreStatus.LoadingPkce]: [],
  },
  pkce: {},
});
